import { createContext } from "react";
export const TopTracksContext = createContext();
